const r = (n) => async (o) => {
  const { getState: s } = n, { tokenHandlers: { subscriptionTokenHandler: e } } = s(), t = await e.refreshSubscriptionToken(o);
  return t == null ? void 0 : t.subscription;
};
export {
  r as getSubscription
};
